import type {Dispatch} from 'redux';

export class DispatchHolder {
  static dispatch: Dispatch;
}
